import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false

if (false || !!document.documentMode) {
  alert(`您現在使用的是IE，
  建議使用Chrome, Firefox, Safari 或 Edge 等瀏覽器瀏覽`)
}

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
